import { PrelevementTypes } from './types'
import { SAVE_PRELEVEMENT } from './actionTypes'
import { PrelevementModalModel } from '../../../types/prelevement/prelevementModalModel'

const initialState: PrelevementModalModel = {
	subscribePrelevementModal: true
}

const prelevement = (
	state: PrelevementModalModel = initialState,
	action: PrelevementTypes
): PrelevementModalModel => {
	switch (action.type) {
		case SAVE_PRELEVEMENT: {
			return 'payload' in action ? action.payload : initialState
		}
		default:
			return state
	}
}

export default prelevement